/**
 * @file
 * Small module which manages resize handlers.
 * Uses rAF for smooth performance.
 * (supports IE9, if rAF polyfill available)
 *
 * @author diego.morales@notch-interactive.com
 *
 * @module helpers/resize-manager
 *
 * @example
 * import resizeManager from './helper/resize-manager';
 *
 * var handlerId = resizeManager.add( () => console.log('resizing!!') );
 *
 * resizeManager.remove(handlerId);
 */

let instance = {},
    isRendering = false,
    handlers = {},
    hId = -1,

    runHandlers = () => {
        for (let hId in handlers) {
            if (handlers.hasOwnProperty(hId)) {
                handlers[hId]();
            }
        }

        isRendering = false;
    },

    onResize = function () {
        if (!isRendering) {
            requestAnimationFrame(runHandlers);
            isRendering = true;
        }
    };

instance.add = (handler) => {
    if (!Object.keys(handlers).length) {
        window.addEventListener('resize', onResize);
    }

    hId++;

    handlers[hId] = handler;

    return hId;
};

instance.remove = (hId) => {
    delete handlers[hId];

    if (!Object.keys(handlers).length) {
        window.removeEventListener('resize', onResize);
    }
};

export default instance;
